import { Directive, HostListener } from "@angular/core";


@Directive({
    selector: '[blockCopyPaste]'
})
export class UiServiceBlockCopyPasteDirective {
    constructor() { }

    @HostListener('paste', ['$event'])
    @HostListener('copy', ['$event'])
    @HostListener('cut', ['$event'])
    blockClipboardEvent(event: ClipboardEvent) {
        event.preventDefault();
    }

    @HostListener('keydown', ['$event'])
    handleKeydown(event: KeyboardEvent): void {
        if((event.ctrlKey || event.metaKey) &&
            ['c', 'v', 'x'].includes(event.key.toLowerCase())) {
            event.preventDefault();
        }
    }
}